import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import MushroomCollection from './components/MushroomCollection';
import HealthBenefits from './components/HealthBenefits';
import Contact from './components/Contact';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <MushroomCollection />
      <HealthBenefits />
      <Contact />
    </div>
  );
}

export default App;
